<template>
  <div class="b">
    <Nav :current="current"></Nav>
    <div class="titleBox">
      <span class="txt l">角色列表</span>
      <el-button
        type="primary"
        size="small"
        v-if="treeBtn.add"
        class="edit l yellow bgBtn"
        @click="addRoles"
        >添加角色
      </el-button>
    </div>
    <div class="seatch">
      
      <div style="display: flex;align-items: center;">
        <span>系统名称:</span> 
        <el-select style="display:flex; align-items: center;" v-model="system" clearable placeholder="">
          <el-option
            v-for="item in systemList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <span>角色名称:</span> <input type="text" v-model="name" @keyup.enter="getTableHeight" />
      </div>
      <span class="el-icon-search" @click="getTableHeight('search')"></span>
      <!-- <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="角色名称:" style="float:left;">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-select v-model="form.system" clearable placeholder="请选择系统">
          <el-option
            v-for="item in systemList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="el-icon-search" @click="getTableHeight"></span>
    </el-form> -->
    </div>
    <div class="el-table-box">
      <el-table
        :data="tableData"
        :empty-text="emptyText"
        :props="defaultProps"
        :cell-style="textColor"
        :height="tableHeight ? tableHeight : 400"
        :max-height="tableHeight ? tableHeight : 0"
        @cell-click="tableClick"
        >
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :min-width="col.minwidth"
          :width="col.width"
          :fixed="col.fixed"
          :type="col.type"
          show-overflow-tooltip
          v-for="(col, index) in listCol"
          :key="index">
          <template v-if="col.prop == 'shipping_address'">
            <!-- <div v-if="scope.row.shipping_address">
							{{JSON.parse(scope.row.shipping_address).province}}{{JSON.parse(scope.row.shipping_address).city}}{{JSON.parse(scope.row.shipping_address).county}}{{JSON.parse(scope.row.shipping_address).address}}
						</div> -->
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <div v-if="treeBtn.edit" class="link-btn border-right l" @click="editHandle(scope.row)">
              编辑
            </div>
            <div v-if="treeBtn.setting" class="link-btn border-right l" @click="roleAuthority(scope.row)">
              权限设置
            </div>
            <div v-if="treeBtn.delete" class="link-btn l" @click="deleteHandle(scope.row)">删除</div>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px;  text-align: center;" >
        <el-pagination
          background
          layout="total, sizes, prev, pager, next,jumper"
          :total="total"
          :current-page="currentPage"  
          :page-sizes="[10, 30, 50, 70, 100]"
          :page-size="pageSize"
          @size-change="changePageSize"
          @current-change="changeCurrentSize"
        >
        </el-pagination>
      </div>
    </div>
    <vxe-modal v-model="isShowDelete" title="温馨提示" width="300" height="180">
      <vxe-form title-align="right" title-width="100">
        <vxe-form-item align="center" span="24">您确定要删除吗？</vxe-form-item>
        <vxe-form-item align="center" span="24">
          <template #default>
            <vxe-button @click="isShowDelete = false">取消</vxe-button>
            <vxe-button
              style="background: #55c4b8; color: #fff"
              @click="deleHandle"
              >确认</vxe-button
            >
          </template>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      name: '',
      system: '',
      systemList: [],
      treeBtn: {
        add: false,
        edit: false,
        delete: false,
        setting: false
      },
      color:'#5DC5B8',
      current: '我的公司',
      isShowDelete: false,
      deleteObj: {}, //要删除的对象
      currentPage: 1,
      pageSize: 10,
      total: 10,
      defaultProps: {
        //  列  :  显示的值
        date: "date",
        name: "name",
        address: "address",
      },
      str: "角色设置",
      tableData: [], //列表数据
      emptyText: ' ',
      tableHeight: "", //表格高度
      listCol: [
        {
          prop: "orderNum",
          label: "序号",
          width: "100",
          fixed: true,
          type: "index",
        },
        {
          prop: "name",
          label: "角色名称",
          id: "roleId",
          minwidth: "200",
        },
        {
          prop: "description", //入库仓库
          label: "角色说明",
          minwidth: "150",
        },
        {
          prop: "toBeAgreed",
          label: "待同意(个)",
          minwidth: "200",
          type : '1'
        },
        {
          prop: "inUse",
          label: "使用中(个)",
          minwidth: "120",
          type : '2'
        },
        {
          prop: "rejected",
          label: "已拒绝(个)",
          minwidth: "120",
          type : '3'
        },
        {
          prop: "deactivated",
          label: "已停用(个)",
          minwidth: "120",
          type : '4'
        },
        {
          prop: "obsolete",
          label: "已废弃(个)",
          minwidth: "120",
          type : '5' 
        },
      ],
    };
  },
  activated() {
  },
  mounted() {
    // 存在 读缓存
    if (sessionStorage.getItem("searchFlag")) {
      let searchForm = JSON.parse(sessionStorage.getItem("searchForm"))
      this.name = searchForm?.name
      this.system = searchForm?.system
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem("searchForm")
    }

    this.getTableHeight();
    // 获取系统列表
    this.getSystemList()
    let listMenuAll = JSON.parse(localStorage.getItem('listMenu'))
    if(listMenuAll && listMenuAll.length){
      for (let index = 0; index < listMenuAll.length; index++) {
        const listMenu = listMenuAll[index];
        if (listMenu.children) {
          this.navList = listMenu.children.map(itemOne => {
            if (itemOne.level === "020103") {//角色
              itemOne["current"] = true
              if (itemOne.children) {
                itemOne.children.forEach((item, index) => {
                  if (item.opCode === "role.add") {
                    this.treeBtn.add = true
                  }
                  if(item.opCode === "role.edit"){
                    this.treeBtn.edit = true
                  }
                  if(item.opCode === "role.delete"){
                    this.treeBtn.delete = true
                  }
                  if(item.opCode === "role.setting"){
                    this.treeBtn.setting = true
                  }
                })
              }
            }
            return itemOne
          })
        }
      }
    }
  },
  methods: {
    getSystemList() {
      this.systemList = JSON.parse(localStorage.getItem('systemList'))
    },
    textColor({row, column, rowIndex, columnIndex}){
      //  console.log(columnIndex ,)
      //  console.log(column,)
      //  console.log(rowIndex,)
      //  console.log(columnIndex)
      // alert(1)
      if(columnIndex == 3 || columnIndex == 4 || columnIndex == 5 || columnIndex == 6 || columnIndex == 7   ){
           return 'color: #5DC5B8;'
      }
      
        // return 'red'
    },

    // 点击某一个单元格触发当前事件
    tableClick(row, column, cell, event){
      let _this =this
      //拿到当前行的数据 ， 根据type来判断点的
      if(column.type == '1'&&row.toBeAgreed>0){
        // console.log(1)
          _this.$router.push({name:'RoleNumber' , query:{id:row.id,roleName:row.name,roleStatus:column.type}})
      }
       if(column.type == '2'&&row.inUse>'0'){
      
          _this.$router.push({name:'RoleNumber' , query:{id:row.id,roleName:row.name,roleStatus:column.type}})
      }
       if(column.type == '3'&&row.rejected>0){
       
          _this.$router.push({name:'RoleNumber' , query:{id:row.id,roleName:row.name,roleStatus:column.type}})
      }
       if(column.type == '4'&&row.deactivated>0){
        
          _this.$router.push({name:'RoleNumber' , query:{id:row.id,roleName:row.name,roleStatus:column.type}})
      }
       if(column.type == '5'&&row.obsolete>0){
        
          _this.$router.push({name:'RoleNumber' , query:{id:row.id,roleName:row.name,roleStatus:column.type}})
      }
      //  console.log(row)
      //  console.log(event.target.value)
    },
    
    changePageSize(val) {
      this.pageSize = val;
      this.getTableHeight();
    },
    changeCurrentSize(val) {
      this.currentPage = val;
      // console.log(val);
      this.getTableHeight();
    },
    getTableHeight(isSearch) {
      let _this = this;
      this.$nextTick(function () {
        // this.clientHeight = `${document.documentElement.clientHeight}`;
        // this.tableHeight = 500 + "px"
        _this.$utils.getTableHeight(_this, 150)//搜索的高度+标题+margin
        if (isSearch && isSearch == 'search') {
          _this.currentPage = 1
        }
        let params = {
          pageNum: _this.currentPage,
          pageSize: _this.pageSize,
          name: _this.name,
          system: _this.system,
        };
        _this.emptyText =' '
        http.get(apiData.roleList, true, params, (res) => {
          if (res.data.code == 200) {
            sessionStorage.removeItem("searchForm");
            sessionStorage.removeItem("searchFlag");
            _this.tableData = res.data.data.list;
            _this.total = res.data.data.totalRow;
          }else{
            _this.$message.error(res.data.msg);
          }
          _this.emptyText = "暂无数据";
        });
      });
    },

    addRoles() {
      this.$router.push({ path: "/company/addRole" });
    },
    roleAuthority(row) {
      sessionStorage.setItem("searchForm", JSON.stringify({
        name: this.name,
        system: this.system,
      }));
      this.$router.push({
        path: '/company/roleAuthority',
        query: {
          roleId: row.id,
          roleName: row.name,
        }
      })
    },
    editHandle(row) {
      console.log(row)
      this.$router.push({
        name: "EditRole", query: {
          name: row.name,
          description: row.description,
          id: row.id,
        }
      });
    },
    deleteHandle(row) {
      var _this = this;
      _this.isShowDelete = true;
      _this.deleteObj = row;
    },
    deleHandle() {
      var _this = this;
      console.log(_this.deleteObj);
      http.delete( apiData.deleteRole,true,{ id: _this.deleteObj.id },(res) => {
          if (res.data.code == 200) {
            _this.isShowDelete = false;
            _this.getTableHeight();
            _this.$message.success("删除成功");
          } else {
            _this.$message.error("删除失败");
          }
        }
      );
    },
  }
};
</script>
<style scoped lang="less">
.seatch {
  margin-left: 0;
}
.b {
  margin: 0 10px;
}
.titleBox {
  margin: 20px auto;
  margin-left: 10px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.zitiyangshi{
  color: #5DC5B8;
  background: red;
}
.seatch-name{
  text-align: left;
  display: flex;
  input{
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
    margin-right: 5px;
  }
  .el-icon-search{
    font-size: 20px;
    display: block;
    padding:0;
  }
}
.zitiyaoshi{
  color: #5DC5B8;
}
.el-table-column{
  color: #5DC5B8;
  background: red;
}
.blue{
  color: #5DC5B8;
}
/deep/
.el-select .el-input .el-select__caret {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>